module.exports = __webpack_public_path__ + "assets/clown.cc2bd42c04d7018a3d4429ef48ad4ebf.png";